import { Mail, Phone, MapPin, CalendarCheck } from "lucide-react";
import { BRAND } from "../data";
import { useBooking } from "../BookingContext";

export default function Footer() {
  const { openBooking } = useBooking();

  return (
    <footer id="contact" data-testid="footer-section" className="relative bg-[#050A15] border-t border-[#1D2847]">
      {/* CTA band */}
      <div className="px-6 md:px-12 lg:px-20 py-20 border-b border-[#1D2847] grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <h2 className="font-display text-3xl md:text-5xl font-black uppercase tracking-tight leading-[0.95]">
            Ready to build on a <span className="gold-text">solid foundation?</span>
          </h2>
          <p className="mt-5 text-lg text-[#A3A8B8] max-w-xl">
            Book your free 15-minute consultation and let's map out the right training for you or your team.
          </p>
          <button
            data-testid="footer-book-btn"
            onClick={() => openBooking("")}
            className="mt-8 inline-flex items-center gap-2 bg-[#D4AF37] text-[#050A15] hover:bg-[#F0C84B] font-bold uppercase tracking-wider px-8 py-4 transition-colors"
          >
            <CalendarCheck size={18} /> Book a Live Session
          </button>
        </div>

        <div className="grid gap-4">
          <a href={`mailto:${BRAND.email}`} data-testid="footer-email" className="group flex items-center gap-4 bg-[#0C142A] border border-[#1D2847] p-5 hover:border-[#D4AF37]/50 transition-colors">
            <span className="p-3 border border-[#D4AF37]/40 text-[#D4AF37] group-hover:bg-[#D4AF37] group-hover:text-[#050A15] transition-colors"><Mail size={20} /></span>
            <div>
              <div className="text-xs uppercase tracking-wider text-[#A3A8B8]">Email</div>
              <div className="text-[#F8F9FA] font-semibold">{BRAND.email}</div>
            </div>
          </a>
          <a href={BRAND.phoneHref} data-testid="footer-phone" className="group flex items-center gap-4 bg-[#0C142A] border border-[#1D2847] p-5 hover:border-[#D4AF37]/50 transition-colors">
            <span className="p-3 border border-[#D4AF37]/40 text-[#D4AF37] group-hover:bg-[#D4AF37] group-hover:text-[#050A15] transition-colors"><Phone size={20} /></span>
            <div>
              <div className="text-xs uppercase tracking-wider text-[#A3A8B8]">Phone</div>
              <div className="text-[#F8F9FA] font-semibold">{BRAND.phone}</div>
            </div>
          </a>
          <div className="flex items-center gap-4 bg-[#0C142A] border border-[#1D2847] p-5">
            <span className="p-3 border border-[#D4AF37]/40 text-[#D4AF37]"><MapPin size={20} /></span>
            <div>
              <div className="text-xs uppercase tracking-wider text-[#A3A8B8]">Location</div>
              <div className="text-[#F8F9FA] font-semibold">{BRAND.address}</div>
            </div>
          </div>
        </div>
      </div>

      {/* bottom */}
      <div className="px-6 md:px-12 lg:px-20 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <img src={BRAND.logo} alt="On This Rock LLC" className="h-10 w-auto" />
          <span className="font-display font-extrabold tracking-tight">ON THIS ROCK <span className="text-[#A3A8B8] text-xs">LLC</span></span>
        </div>
        <p className="text-sm text-[#A3A8B8]">© {new Date().getFullYear()} On This Rock LLC. All rights reserved.</p>
      </div>
    </footer>
  );
}
